<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        :width="props.size ? props.size[0] : null"
        :height="props.size ? props.size[1] : null"
        :fill="props.color ? props.color : null"
    >
        <template v-if="url.includes('/svg-sprite') || url.includes('/assets')">
            <title v-if="props.title">{{ props.title }}</title>
            <use :href="url" :xlink:href="url"></use>
        </template>
        <template v-else>
            <image :xlink:href="url"
                :width="props.size ? props.size[0] : null"
                :height="props.size ? props.size[1] : null"
            />
        </template>
    </svg>
</template>

<script setup>
import { computed } from 'vue';

// import stores from '@/stores';

const others = stores.others();

const props = defineProps({
    icon: { type: String, default: '' },
    sprite: { type: String, default: '' },
    size: { type: [Array, null], default: () => ['1em', '1em'] },
    color: { type: [String, null], default: null },
    title: { type: String, default: '' }
});

const url = computed(() => {
    if (props.icon.includes('https://')) {
        return props.icon;
    }

    const baseSpriteUrl = others.getSvgSpriteUrl(props.sprite);
    
    return `${baseSpriteUrl}#${props.icon}`;
});
</script>

<style lang="scss" scoped>
.direction-rtl svg.rtl-sensitive {
    transform: scaleX(-1);
}
</style>